import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import { FaEdit, FaTrash } from 'react-icons/fa';
import './Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const Nucleos = () => {
  const [nucleos, setNucleos] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    nucleo: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarNucleos = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/nucleos`);
      if (!response.ok) {
        throw new Error('Erro ao buscar núcleos');
      }
      const data = await response.json();
      const formatados = data.map((item) => ({
        id: item.id_nucleo,
        nucleo: item.nome_nucleo,
        ativo: item.ativo,
      }));
      setNucleos(formatados);
    } catch (error) {
      console.error('Erro ao carregar núcleos:', error);
      alert('Erro ao carregar núcleos. Verifique a conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarNucleos();
  }, []);

  const filteredNucleos = nucleos.filter(nucleo =>
    nucleo.nucleo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const payload = {
        nome_nucleo: formData.nucleo,
        ativo: formData.ativo,
      };

      if (editingId) {
        const response = await fetch(`${API_BASE_URL}/nucleos/${editingId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error('Erro ao atualizar núcleo');
        }

        const atualizado = await response.json();

        setNucleos(
          nucleos.map((nucleo) =>
            nucleo.id === editingId
              ? {
                  id: atualizado.id_nucleo,
                  nucleo: atualizado.nome_nucleo,
                  ativo: atualizado.ativo,
                }
              : nucleo
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/nucleos`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error('Erro ao criar núcleo');
        }

        const criado = await response.json();

        setNucleos([
          ...nucleos,
          {
            id: criado.id_nucleo,
            nucleo: criado.nome_nucleo,
            ativo: criado.ativo,
          },
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar núcleo:', error);
      alert('Erro ao salvar núcleo. Verifique os dados e tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (nucleo) => {
    setFormData({
      nucleo: nucleo.nucleo,
      ativo: nucleo.ativo
    });
    setEditingId(nucleo.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este núcleo?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/nucleos/${id}`, {
          method: 'DELETE',
        });

        if (!response.ok && response.status !== 204) {
          throw new Error('Erro ao excluir núcleo');
        }

        setNucleos(nucleos.filter((nucleo) => nucleo.id !== id));
      } catch (error) {
        console.error('Erro ao excluir núcleo:', error);
        alert('Erro ao excluir núcleo. Tente novamente.');
      }
    }
  };

  const resetForm = () => {
    setFormData({ nucleo: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const nucleoSelecionado = nucleos.find((n) => n.id === id);
    if (!nucleoSelecionado) {
      return;
    }

    const novoAtivo = !nucleoSelecionado.ativo;

    try {
      const response = await fetch(`${API_BASE_URL}/nucleos/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome_nucleo: nucleoSelecionado.nucleo,
          ativo: novoAtivo,
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do núcleo');
      }

      setNucleos(
        nucleos.map((nucleo) =>
          nucleo.id === id ? { ...nucleo, ativo: novoAtivo } : nucleo
        )
      );
    } catch (error) {
      console.error('Erro ao atualizar status do núcleo:', error);
      alert('Erro ao atualizar status do núcleo. Tente novamente.');
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Núcleos</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Núcleo
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Núcleo' : 'Cadastrar Núcleo'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="nucleo">Nome do Núcleo *</label>
              <input
                type="text"
                id="nucleo"
                value={formData.nucleo}
                onChange={(e) => setFormData({...formData, nucleo: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite o nome do núcleo"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? 'Salvando...' : (editingId ? 'Atualizar' : 'Cadastrar')}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar núcleos..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredNucleos.length} registro(s) encontrado(s)</span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Núcleo</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredNucleos.map(nucleo => (
                  <tr key={nucleo.id}>
                    <td>{nucleo.id}</td>
                    <td>{nucleo.nucleo}</td>
                    <td className="status-cell">
                      <div className="status-toggle-wrapper">
                        <Toggle
                          checked={nucleo.ativo}
                          onChange={() => handleToggleStatus(nucleo.id)}
                          id={`toggle-${nucleo.id}`}
                        />
                      </div>
                    </td>
                    <td className="acoes-col">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(nucleo)}
                          title="Editar"
                        >
                          <FaEdit size={16} />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(nucleo.id)}
                          title="Excluir"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Nucleos;
